import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import * as BookingAlertCM from '../contentModels/BookingAlertCM';
import { buildBookingAlertWhere } from '../helpers/bookingAlertFilter';
import { IApplicationState } from '../store';


interface BookingAlertData {
    bookingAlertCollection: { items: BookingAlertCM.BookingAlert[] }
}

const useGlobalBookingAlert = (language: string = "en") => {

    const previewMode = useSelector((state: IApplicationState) => state.ui.previewMode);
    const flags = useSelector((state: IApplicationState) => state.featureFlags.flags);
    const flagsLoading = useSelector((state: IApplicationState) => state.featureFlags.loading);
    const flagsLoaded = useSelector((state: IApplicationState) => state.featureFlags.hasLoaded);
    const flagsAbandoned = useSelector((state: IApplicationState) => state.featureFlags.abandoned);

    const where = useMemo(() => buildBookingAlertWhere(flags), [flags]);

    const query = useMemo(() => gql`
        query GetBookingAlerts {
            bookingAlertCollection(
                locale: "${language}",
                ${previewMode ? 'preview:true' : ''}
                ${where ? `where: ${where},` : ''}
                limit: 5
            ) {
                items {
                    ${BookingAlertCM.query}
                }
            }
        }
    `, [language, previewMode, where]);

    // Wait for real flag values so an alert behind a disabled flag never shows briefly.
    // Flags reload on venue change while hasLoaded stays true, so also wait while loading to avoid the previous venue's alerts.
    // If loading is abandoned, KnownFlag flags keep their default of false and alerts tagged with them stay hidden.
    const flagsReady = (flagsLoaded || flagsAbandoned) && !flagsLoading;
    const { loading, error, data } = useQuery<BookingAlertData>(query, { skip: !flagsReady });

    // const liveData = useContentfulLiveUpdates(data);
    const liveData = data;
    return { loading, error, liveData };
};

export default useGlobalBookingAlert;
